import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { HIGHLIGHT_ACTIVE_TREE_ITEM } from 'src/redux/pull-request/actions';

type ReturnValue = (inView: boolean, fileHref: string) => void;

export const useHandleDiffObserverOnChange = (): ReturnValue => {
  const dispatch = useDispatch();

  return useCallback(
    (inView: boolean, fileHref: string) => {
      // diff is 'in view' when just below the sticky header
      if (inView) {
        dispatch({
          type: HIGHLIGHT_ACTIVE_TREE_ITEM,
          payload: fileHref,
        });
      }
    },
    [dispatch]
  );
};
